import React from 'react';

import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';

import globalMessages from 'translations/messages/global-messages';

const Control = ({ intl, size = 16, title, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" {...props}>
    <title>{title || intl.formatMessage(globalMessages.control)}</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8047 3.52858C14.0651 3.78892 14.0651 4.21103 13.8047 4.47138L6.4714 11.8047C6.21106 12.0651 5.78894 12.0651 5.5286 11.8047L2.19526 8.47138C1.93491 8.21103 1.93491 7.78892 2.19526 7.52858C2.45561 7.26823 2.87772 7.26823 3.13807 7.52858L6 10.3905L12.8619 3.52858C13.1223 3.26823 13.5444 3.26823 13.8047 3.52858Z"
    />
  </svg>
);

Control.propTypes = {
  intl: PropTypes.object.isRequired,
  size: PropTypes.number,
  title: PropTypes.string,
};
export default compose(injectIntl)(Control);
